
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.61 16.69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M6.81 16.69l-.2-.08C2.72 15 0 11.31 0 7.76V1L3.69.16V2l1.16-.09V.12h.45a16.47 16.47 0 0 1 3 0h.44v1.82L9.92 2V.16l3.69.84v6.76c0 3.55-2.71 7.19-6.61 8.85zM1 1.82v5.94c0 3.05 2.43 6.32 5.81 7.84 3.37-1.52 5.8-4.79 5.8-7.84V1.82l-1.69-.4V3.1l-3.16-.23V1a15 15 0 0 0-1.91 0v1.87l-3.16.23V1.42z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M6.87 8.11A2.21 2.21 0 1 1 9.08 5.9a2.21 2.21 0 0 1-2.21 2.21zm0-3.42A1.21 1.21 0 1 0 8.08 5.9a1.21 1.21 0 0 0-1.21-1.21z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M7.9 11.49v3.63a9.86 9.86 0 0 0 1-.69v-2.94a1.58 1.58 0 0 1 1.34-1.59l.43-.06V7.33l-.73.37a7.14 7.14 0 0 1-3.07.87 7.52 7.52 0 0 1-3.19-.87L3 7.33v2.51l.42.06a1.58 1.58 0 0 1 1.34 1.59v2.94a9.86 9.86 0 0 0 1 .69v-3.63A2.52 2.52 0 0 0 4 9v-.07a8.07 8.07 0 0 0 2.9.64 7.4 7.4 0 0 0 2.8-.64V9a2.53 2.53 0 0 0-1.8 2.49z"}})])])])
          )
        }
      }
    